export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7906.a4d60e1c.jpg";